

























import TemplateEditorPlaceholderDropdown from "@/components/template/TemplateEditorPlaceholderDropdown.vue";
import Debug from "@/components/utility/Debug.vue";
import SideCard from "@/components/utility/SideCard.vue";
import { SignatureTokenEnum } from "@/lib/enum/signature-token.enum";
import {
  isQrCodeToken,
  isSignatureToken,
  SignatureImageTokenConfig,
  SignatureQRTokenConfig,
  SignatureTokenConfigType
} from "@/lib/signature-token.utils";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { SignDocumentTokenDtoGen } from "@/services/sign/v1/data-contracts";
import { DocumentTemplateModule } from "@/store/modules/document-template.store";
import { FeatureModule } from "@/store/modules/feature.store";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import { IDocumentPageMeta } from "./DocumentDetailEditorMixin.vue";
import DocumentDetailMixin from "./DocumentDetailMixin.vue";
import DocumentTemplateDetailTokenListExpansionHeader from "./DocumentTemplateDetailTokenListExpansionHeader.vue";
import { getDocumentEditorPositionOptions } from "./ImagePositionSelector.vue";

@Component({
  components: { SideCard, TemplateEditorPlaceholderDropdown, DocumentTemplateDetailTokenListExpansionHeader, Debug }
})
export default class DocumentTemplateDetailTokenList extends mixins(
  DarkModeHighlightMixin,
  PermissionMixin,
  DocumentDetailMixin
) {
  @Prop()
  currentPageNumber!: number;

  @Prop()
  isLoadingSave!: boolean;

  @Prop({ default: "calc(100vh - 274px - 210px)" })
  height!: string;

  /**
   * Edit values or allow dropdowns
   */
  @Prop({ default: false })
  isEditValue!: boolean;

  /**
   * Suppress editing of values
   */
  @Prop({ default: false })
  disabled!: boolean;

  @Prop()
  page!: IDocumentPageMeta;

  get selectedItem() {
    return DocumentTemplateModule.highlightedToken;
  }

  get selectedPage() {
    return DocumentTemplateModule.currentPage;
  }

  isSignatureWithQR(token: SignDocumentTokenDtoGen) {
    this.$log.debug(token.token, isQrCodeToken(token.token));
    return isQrCodeToken(token.token);
  }

  change(isQrCode: boolean, token: SignDocumentTokenDtoGen) {
    this.$log.debug(`Change Type ${isQrCode}`);

    let signatureToken: SignatureTokenConfigType = SignatureQRTokenConfig;
    if (!isQrCode) {
      signatureToken = SignatureImageTokenConfig;
    }

    const x = token.coordinates.x + token.coordinates.w / 2 - signatureToken.w / 2;
    const y = token.coordinates.y + token.coordinates.h / 2 - signatureToken.h / 2;
    token.coordinates.x = x;
    token.coordinates.y = y;
    token.coordinates.h = signatureToken.h;
    token.coordinates.w = signatureToken.w;
    token.token = signatureToken.token;
  }

  get isSignatureFormActive() {
    return FeatureModule.isSignatureFormActive;
  }

  get documentTokens() {
    return DocumentTemplateModule.documentTokens;
  }

  get pageTokens() {
    return this.documentTokens[this.currentPageNumber];
  }

  getDocumentEditorPositionOptions(e: SignDocumentTokenDtoGen) {
    return getDocumentEditorPositionOptions(e, this.page);
  }

  unselect() {
    DocumentTemplateModule.setHighlightedToken(-1);
  }

  getIsSignature(token: string) {
    return isSignatureToken(token);
  }

  getIsTextField(token: string) {
    return SignatureTokenEnum.FREE_TEXT_TOKEN === token;
  }

  removeDocumentToken(documentToken: SignDocumentTokenDtoGen) {
    DocumentTemplateModule.removeDocumentToken({ page: this.currentPageNumber, documentToken });
    this.unselect();
  }

  setCurrentPage(page: number) {
    this.$emit("setCurrentPage", page);
  }

  setHighlightedToken(page: number, token: number) {
    this.$emit("setCurrentPage", page);
    this.highlightedToken = token;
  }

  updateToken(documentToken: SignDocumentTokenDtoGen, newToken: string) {
    documentToken.token = newToken;
  }
}
